var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-card',[_c('v-card-title',[_c('AppLogo')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }